import React from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import ContentConstants from '../../contentConstants';
import { IApplicationState } from '../../store';
import { ActionCreators as AudienceListActionCreators } from '../../store/AudienceListStore';
import { WarningModal } from '../common';

export const AudienceWarningModal = () => {
	const dispatch = useDispatch();
	const { pendingDeleteAudience, warningModalOpen } = useSelector((state: IApplicationState) => state.audienceList);

	return (
		<WarningModal
			isOpen={warningModalOpen}
			onClose={() => dispatch(AudienceListActionCreators.ToggleWarningModal(false))}
			onSubmit={() => dispatch(AudienceListActionCreators.DeleteAudience(pendingDeleteAudience!))}
			contentHeadline={ContentConstants.WARNING_MODAL_DELETE_HEADLINE}
			contentBody={warningModalContent()}
		/>
	);

	function warningModalContent() {
		let warningModalContentBody = ContentConstants.WARNING_MODAL_DELETE_BODY;
		if (pendingDeleteAudience) {
			warningModalContentBody = _.replace(warningModalContentBody, /{name}/g, pendingDeleteAudience.audienceName);
		}
		return warningModalContentBody;
	}
};
